import {
  jeeMainsAdvanceReservationQuotas,
  mhtcetReservationQuotas,
  wbjeeMainsAdvanceReservationQuotas
} from '../../constants/CollegePredictorConstants';

export const getCutOffRangeFromExpectedRank = (
  expectedRank: number
): number[] => {
  const maxRank = 500000;
  if (expectedRank <= 50) {
    return [Math.max(1, expectedRank - 3), maxRank];
  } else if (expectedRank <= 100) {
    return [expectedRank - 10, maxRank];
  } else if (expectedRank <= 1000) {
    return [expectedRank - 30, maxRank];
  } else if (expectedRank <= 5000) {
    return [expectedRank - 50, maxRank];
  } else if (expectedRank <= 10000) {
    return [expectedRank - 100, maxRank];
  } else if (expectedRank <= 16000) {
    return [expectedRank - 500, maxRank];
  } else if (expectedRank <= 30000) {
    return [expectedRank - 800, maxRank];
  } else if (expectedRank <= 50000) {
    return [expectedRank - 1000, maxRank];
  } else if (expectedRank <= 100000) {
    return [expectedRank - 1200, maxRank];
  } else {
    return [expectedRank - 2000, maxRank];
  }
};

export const getCutOffRangeFromExpectedPercentile = (
  expectedPercentile: number
): number[] => {
  if (expectedPercentile < 50) {
    return [0, expectedPercentile + 2.5];
  } else if (expectedPercentile < 70) {
    return [0, expectedPercentile + 2];
  }
  if (expectedPercentile < 80) {
    return [0, expectedPercentile + 1];
  }
  if (expectedPercentile < 90) {
    return [0, expectedPercentile + 0.8];
  }
  return [0, Math.min(100, expectedPercentile + 0.5)];
};

export const getReservationCategoryCodes = (
  filteredExamNameEnum: string,
  selectGender: string,
  reservationCategoryCode: string,
  selectedQuota?: string
): string[] => {
  let reservationCategoryCodes: string[] = [];
  if (filteredExamNameEnum === 'JEE_MAINS_2024') {
    const jeeMainsQuotas = ['AI', 'GO', 'HS', 'JK', 'LA', 'OS'];
    for (const quota of jeeMainsQuotas) {
      const categoryQuota =
        selectGender === 'Female'
          ? `${reservationCategoryCode}_GIRLS_${quota}`
          : `${reservationCategoryCode}_${quota}`;

      if (jeeMainsAdvanceReservationQuotas.includes(categoryQuota)) {
        reservationCategoryCodes.push(categoryQuota);
      }
    }
  } else if (filteredExamNameEnum === 'JEE_ADVANCE_2024') {
    const aiQuotaCategoryCode =
      selectGender === 'Female'
        ? `${reservationCategoryCode}_GIRLS_AI`
        : `${reservationCategoryCode}_AI`;
    reservationCategoryCodes = [aiQuotaCategoryCode];
  } else if (filteredExamNameEnum === 'WBJEE_2024') {
    const quota = selectedQuota === 'All India' ? 'AI' : 'HS';
    const categoryQuota = `${reservationCategoryCode}_${quota}`;
    if (wbjeeMainsAdvanceReservationQuotas.includes(categoryQuota)) {
      reservationCategoryCodes.push(categoryQuota);
    }
  } else if (filteredExamNameEnum === 'WBJEE_MAINS_2024') {
    reservationCategoryCodes.push('OPEN');
  } else if (filteredExamNameEnum === 'MHTCET_2024') {
    const mhtcetMainsQuotas = ['I', 'INP', 'VII', 'II', 'IND'];
    for (const quota of mhtcetMainsQuotas) {
      const categoryQuota = `${reservationCategoryCode}_${quota}`;
      if (mhtcetReservationQuotas.includes(categoryQuota)) {
        reservationCategoryCodes.push(categoryQuota);
      }
    }
  }

  return reservationCategoryCodes.length > 0
    ? reservationCategoryCodes
    : [reservationCategoryCode];
};
